import { useEffect } from "react"
import HeaderImage from "../../assets/imgx.png"
import data from "./data"
import AOS from "aos"
import 'aos/dist/aos.css'
import "./header.css"


const Header = () => {
    useEffect(() => {
        AOS.init({ duration: 2000 })
    }, [])
    return (
        <header id="header">
            <div className="container header__container">
                <div className="header__profile" data-aos="zoom-in-up">
                    <img src={HeaderImage} alt="Header Portrait" />
                </div>
                <h3 data-aos="zoom-out-up">Joseph Makinde</h3>
                <p data-aos="zoom-in-down">Welcome to portfolio! I'm thrilled to share with you some of my favorite projects and experiences in the field. I create websites that are not only aesthetically pleasing but also user-friendly, efficient, and accessible.</p>
                <div className="header__cta">
                    <a href="#contact" className="btn primary" data-aos="zoom-in-left">Let's Talk</a>
                    <a href="#portfolio" className="btn light" data-aos="zoom-in-right">My Projects</a>
                </div>
                <div className="header__socials">
                    {
                        data.map(item => <a key={item.id} href={item.link} target="_blank" rel="noopener noreferrer">{item.icon}</a>)
                    }
                </div>
            </div>
        </header>
    )
}

export default Header